// Rào lỗi: 1 màn bị lỗi khi vẽ thì chỉ màn đó hiện thông báo + nút thử lại — thanh trên và các màn khác vẫn dùng được
// (không trắng cả trang). Đổi màn ⇒ khoaReset đổi ⇒ rào tự gỡ lỗi cũ.
//   * `im`: phần phụ (vd dải cảnh báo cầu) — lỗi thì ẩn hẳn, không chiếm chỗ.
//   * `toanTrang`: rào ngoài cùng (main.tsx) — phần nằm ngoài rào màn (thanh trên, dải cầu, cổng đăng nhập) lỗi thì hiện trang báo lỗi
//     có nút "Xoá bộ nhớ tạm & tải lại" thay vì trắng trang (sự cố 05/11/2026).
import { Component, type ReactNode } from "react";
import { xoaCacheVaTaiLai } from "../api/queryClient";

interface Props { children: ReactNode; khoaReset?: string; im?: boolean; toanTrang?: boolean }
interface State { loi: Error | null }

export class RaoLoi extends Component<Props, State> {
  state: State = { loi: null };

  static getDerivedStateFromError(loi: Error): State { return { loi }; }

  componentDidUpdate(truoc: Props) {
    if (truoc.khoaReset !== this.props.khoaReset && this.state.loi) this.setState({ loi: null });
  }

  componentDidCatch(loi: Error) {
    console.error("Lỗi giao diện:", loi.message);
  }

  render() {
    const loi = this.state.loi;
    if (!loi) return this.props.children;
    if (this.props.im) return null;
    const taiMa = /dynamically imported module|Loading chunk|Importing a module script failed/i.test(loi.message);
    return (
      <section className="screen" style={this.props.toanTrang ? { minHeight: "100vh" } : undefined}>
        <div className="empty">
          <div style={{ display: "grid", gap: 10, justifyItems: "center" }}>
            <h3>{taiMa ? "Có bản web mới — cần tải lại trang" : this.props.toanTrang ? "Web gặp lỗi khi hiển thị" : "Màn này gặp lỗi"}</h3>
            <p style={{ margin: 0 }} className="small">{taiMa ? "Bấm tải lại để dùng bản mới nhất." : loi.message}</p>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", justifyContent: "center" }}>
              {taiMa || this.props.toanTrang ? (
                <button type="button" className="btn primary" onClick={() => window.location.reload()}>Tải lại trang</button>
              ) : (
                <button type="button" className="btn primary" onClick={() => this.setState({ loi: null })}>Thử lại</button>
              )}
              {!taiMa && (
                <button type="button" className="btn" title="Bỏ dữ liệu tạm lưu trên máy này, tải lại toàn bộ từ máy chủ (không mất dữ liệu đã lưu)"
                  onClick={() => void xoaCacheVaTaiLai()}>Xoá bộ nhớ tạm &amp; tải lại</button>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }
}
